import React from "react";
import LmsTable from "../ui/LmsTable";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";

const CloseAccountingMonthAddForm = () => {
  const [{ data = {} }] = useFetchData("accounting/month-close-initial-data");
  const myForm = new BCFormController(
    { ...data, lastClosedMonth: data.lastCosedMonth },
    {
      submitSuffix: "accounting/month-close",
      initIsDisabled: true,
      clearSuffixesOnSubmit: ["accounting/month-close-initial-data"],
    }
  );

  myForm.addCenteredGroup([
    myForm.getCalendarField("Last Closed Month", { name: "lastClosedMonth" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Month End Date", { name: "monthEndDate", required: true }),
  ]);

  return (
    <LmsFormGenerator
      myForm={myForm}
      actions={[{ action: "save", text: "Close Month" }, "close"]}
    />
  );
};

const NetSuiteDataModalContent = ({ netSuitDataId, setIsModalOpen }) => {
  const myForm = new BCFormController({});
  myForm.addComponent(
    <LmsTable apiSuffix={`/accounting/net-suite-data/${netSuitDataId}`} skipClick />
  );

  return (
    <LmsFormGenerator
      myForm={myForm}
      actions={[
        {
          text: "Close",
          handleClick: () => setIsModalOpen(false),
          icon: GlobalConstants.Icons.CLOSE,
        },
      ]}
    />
  );
};

const CloseAccountingMonthTable = () => (
  <LmsTable
    apiSuffix="/accounting/month-close"
    sortable={["Month End Date"]}
    columnLabelsDictionary={{ createdOn: "Date Closed" }}
    actionButtons={[
      "add",
      "export",
      {
        text: "Check NetSuite Data",
        action: GlobalConstants.TableDefaultActions.MODAL_BUTTON,
        isDisabled: (checkedItems: number[]): boolean => checkedItems.length !== 1,
        modalContent: (setIsModalOpen, { checkedIds }) => (
          <NetSuiteDataModalContent netSuitDataId={checkedIds[0]} setIsModalOpen={setIsModalOpen} />
        ),
      },
    ]}
  />
);

const LmsServicingCloseAccountingMonth = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isActionAllowed } = useParseRouteActions(params, ["add"]);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <CloseAccountingMonthTable />}
      {isAdd && <CloseAccountingMonthAddForm />}
    </>
  );
};

export default LmsServicingCloseAccountingMonth;
